require('./errores.js');
require('./choices.js');
require('./actividades.js');
require('./asistencias.js');
require('./empresas.js');
require('./modales.js');
require('./productos.js');
require('./users.js');
require('./recibos.js');
require('./socios.js');
require('./home.js');
require('./publico.js');
require('./horario.js');
require('./facturas.js');
require('./documento.js');